import { fallBackImage } from "../CustomImage";

export const sectionContent = (fields, isProduct) => {
    // product
    const productTitle =
        fields?.page?.fields?.product?.fields?.productTitle || "";
    const productCategories =
        fields?.page?.fields?.product?.fields?.productCategories?.map(
            (p) => p?.fields?.categoryName
        ) || [];
    const productDescription =
        fields?.page?.fields?.product?.fields?.productDescription || "";
    const prodcutUserType =
        fields?.page?.fields?.product?.fields?.userType?.map(
            (u) => u?.fields?.title
        ) || [];
    const productUserExperienceLevel =
        fields?.page?.fields?.product?.fields?.userExperienceLevel?.map(
            (u) => u.fields?.title
        ) || [];
    const productUseCase =
        fields?.page?.fields?.product?.fields?.useCase?.map(
            (u) => u?.fields?.title
        ) || [];
    const productApplicableTime =
        fields?.page?.fields?.product?.fields?.applicableTime?.map(
            (a) => a?.fields?.title
        ) || [];

    // article
    const showcaseImage =
        fields?.page?.fields?.article?.fields?.showcaseImage || fallBackImage;
    const articleTitle =
        fields?.page?.fields?.article?.fields?.articleTitle || "";
    const summary = fields?.page?.fields?.article?.fields?.summary || "";
    const publishedAt =
        fields?.page?.fields?.article?.fields?.publishedAt || "";
    const articleCategories =
        fields?.page?.fields?.article?.fields?.articleCategories?.map(
            (a) => a?.fields?.categoryName
        ) || [];
    const articleUserType =
        fields?.page?.fields?.article?.fields?.userType?.map(
            (u) => u?.fields?.title
        ) || [];
    const articleUserExperienceLevel =
        fields?.page?.fields?.article?.fields?.userExperienceLevel.map?.(
            (u) => u?.fields?.categoryName
        ) || [];
    const poolType =
        fields?.page?.fields?.article?.fields?.poolType?.map(
            (p) => p?.fields?.categoryName
        ) || [];
    const poolShape =
        fields?.page?.fields?.article?.fields?.poolShape?.map(
            (p) => p?.fields?.categoryName
        ) || [];
    const poolSize =
        fields?.page?.fields?.article?.fields?.poolSize?.map(
            (p) => p?.fields?.categoryName
        ) || [];

    return isProduct
        ? {
              productTitle,
              productCategories,
              productDescription,
              prodcutUserType,
              productUserExperienceLevel,
              productUseCase,
              productApplicableTime,
          }
        : {
              showcaseImage,
              articleTitle,
              summary,
              publishedAt,
              articleCategories,
              articleUserType,
              articleUserExperienceLevel,
              poolType,
              poolShape,
              poolSize,
          };
};
